//#region src/assets/vana-pay-logo.svg
var vana_pay_logo_default = "" + new URL("vana-pay-logo-CqVpPWJV.svg", import.meta.url).href;
//#endregion
export { vana_pay_logo_default as default };

//# sourceMappingURL=vana-pay-logo.js.map